export const DEFAULT_SEARCH_LIMIT = 20;
